import { alpha } from "@mui/material";

/**
 * Determines the status of a table based on active orders
 * @param {Object} table - Table object
 * @returns {string} - "occupied" or "available"
 */
export const getTableStatus = (table) => {
    const hasActiveOrders = table.Orders && table.Orders.length > 0;
    return hasActiveOrders ? "occupied" : "available";
};

/**
 * Returns styling configuration for table status
 * @param {string} status - Table status
 * @param {Object} theme - MUI theme object
 * @returns {Object} - Status color configuration
 */
export const getStatusColor = (status, theme) => {
    switch (status) {
        case "available":
            return {
                bg: alpha(theme.palette.success.main, 0.1),
                color: theme.palette.success.main,
                text: "Available",
            };
        case "occupied":
            return {
                bg: alpha(theme.palette.warning.main, 0.1),
                color: theme.palette.warning.main,
                text: "Occupied",
            };
        default:
            return {
                bg: alpha(theme.palette.grey[500], 0.1),
                color: theme.palette.grey[500],
                text: "Unknown",
            };
    }
};

/**
 * Groups tables by location
 * @param {Array} tables - Array of table objects
 * @returns {Object} - Tables grouped by location
 */
export const groupTablesByLocation = (tables) => {
    const grouped = {};
    tables.forEach((table) => {
        const location = table.location || "Unassigned";
        if (!grouped[location]) {
            grouped[location] = [];
        }
        grouped[location].push(table);
    });
    return grouped;
};

/**
 * Calculates table statistics
 * @param {Array} tables - Array of table objects
 * @returns {Object} - Statistics object with total, available, and occupied counts
 */
export const calculateTableStats = (tables) => {
    const stats = {
        total: tables.length,
        available: 0,
        occupied: 0,
    };

    tables.forEach((table) => {
        const status = getTableStatus(table);
        if (status === "available") {
            stats.available++;
        } else if (status === "occupied") {
            stats.occupied++;
        }
    });

    return stats;
};
